import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    // Initialization logic here
    console.log('Settings initialized');
  }
}
